import React, { useEffect, useState, useRef, Component } from 'react';
import { Check, Clock, ShieldCheck, Map, BookOpen, Layout, Globe2, Leaf, TrendingUp, Zap, Star, Users, TrendingUp as Fire, AlertCircle, Gift } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { MetaPixel } from '../components/MetaPixel';
import { PurchasePopup } from '../components/PurchasePopup';
import { Testimonials } from '../components/Testimonials';
import { Bonuses } from '../components/Bonuses';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/nvSGSoEhbsxkFnof3MkcN4/PROYECTOS_Anuales_(7).png';
const CHECKOUT_URL = 'https://checkout7.edulabs.online/cart/44539197423685:1';
// Countdown Timer Component
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-2" data-id="element-44">
      <Clock className="w-4 h-4" data-id="element-45" />
      <div className="flex gap-1 font-mono text-sm font-medium" data-id="element-46">
        <span data-id="element-47">{String(timeLeft.hours).padStart(2, '0')}</span>
        <span data-id="element-48">:</span>
        <span data-id="element-49">{String(timeLeft.minutes).padStart(2, '0')}</span>
        <span data-id="element-50">:</span>
        <span data-id="element-51">{String(timeLeft.seconds).padStart(2, '0')}</span>
      </div>
    </div>;
}
// Social Proof Notification
function SocialProofNotification() {
  const [show, setShow] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const names = ['María de Buenos Aires', 'Carlos de Córdoba', 'Ana de Rosario', 'Jorge de Mendoza', 'Laura de Santa Fe'];
  useEffect(() => {
    const showNotification = () => {
      setCurrentName(names[Math.floor(Math.random() * names.length)]);
      setShow(true);
      setTimeout(() => setShow(false), 4000);
    };
    const interval = setInterval(showNotification, 8000);
    setTimeout(showNotification, 2000);
    return () => clearInterval(interval);
  }, []);
  if (!show) return null;
  return <div className="fixed bottom-6 left-6 bg-white rounded-xl shadow-2xl p-4 max-w-sm z-50 border-2 border-green-500 animate-slide-in" data-id="element-52">
      <div className="flex items-center gap-3" data-id="element-53">
        <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-54">
          <Check className="w-5 h-5 text-white" data-id="element-55" />
        </div>
        <div data-id="element-56">
          <p className="font-bold text-gray-900 text-sm" data-id="element-57">{currentName}</p>
          <p className="text-gray-600 text-xs" data-id="element-58">Acaba de comprar el Megapack</p>
        </div>
      </div>
    </div>;
}
export function SalesPage() {
  const purchaseRef = useRef<HTMLDivElement>(null);
  const scrollToPurchase = () => {
    purchaseRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <div className="min-h-screen bg-gradient-to-b from-white via-blue-50/30 to-white font-sans text-gray-900 overflow-x-hidden" data-id="element-59">
      <MetaPixel data-id="element-60" />
      <PurchasePopup data-id="element-61" />
      <SocialProofNotification data-id="element-62" />

      {/* Subtle Urgency Bar */}
      <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-2 px-4 z-50 shadow-sm" data-id="element-63">
        <div className="max-w-6xl mx-auto flex items-center justify-between text-xs md:text-sm" data-id="element-64">
          <span className="font-medium" data-id="element-65">
            🔥 Oferta especial por tiempo limitado
          </span>
          <CountdownTimer data-id="element-66" />
        </div>
      </div>

      {/* HERO SECTION - Optimized for mobile */}
      <header className="bg-gradient-to-b from-white to-blue-50/50 text-gray-900 pt-14 pb-8 px-4 text-center" data-id="element-67">
        <div className="max-w-4xl mx-auto" data-id="element-68">
          <div className="inline-block bg-gradient-to-r from-blue-600 to-blue-500 text-white font-bold px-4 py-1.5 rounded-full mb-3 text-xs uppercase tracking-wider shadow-lg" data-id="element-69">
            ✨ Para Docentes de Geografía
          </div>

          <h1 className="text-3xl md:text-4xl font-black mb-2 leading-tight text-gray-900 tracking-tight" data-id="element-70">
            🌍 MEGAPACK
            <br data-id="element-71" />
            GEOGRAFÍA LISTA
          </h1>

          <div className="mb-3 cursor-pointer group" onClick={scrollToPurchase} data-id="element-72">
            <img src={PRODUCT_IMAGE} alt="Megapack Geografía Lista" className="w-full max-w-[220px] md:max-w-[280px] mx-auto transition-transform duration-300 group-hover:scale-105" data-id="element-73" />
          </div>

          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-3 max-w-2xl mx-auto" data-id="element-74">
            Entrá al aula con todo resuelto
          </h2>

          <p className="text-base md:text-lg text-gray-600 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-75">
            Clases listas, claras y aplicables para nivel medio
            <br data-id="element-76" />
            <span className="text-blue-600 font-bold mt-1 block text-lg" data-id="element-77">
              📚 Material anual completo
            </span>
          </p>

          <div className="flex flex-col items-center gap-3 mb-4" data-id="element-78">
            <Button onClick={scrollToPurchase} size="lg" className="shadow-xl" data-id="element-79">
              QUIERO MIS CLASES LISTAS
            </Button>

            <div className="flex flex-wrap items-center justify-center gap-4 text-xs md:text-sm text-gray-600" data-id="element-80">
              <span className="flex items-center gap-1" data-id="element-81">
                <Check className="w-3 h-3 md:w-4 md:h-4 text-green-500" data-id="element-82" />{' '}
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-83">
                <Check className="w-3 h-3 md:w-4 md:h-4 text-green-500" data-id="element-84" /> Sin
                suscripción
              </span>
              <span className="flex items-center gap-1" data-id="element-85">
                <Check className="w-3 h-3 md:w-4 md:h-4 text-green-500" data-id="element-86" />{' '}
                Garantía 7 días
              </span>
            </div>
          </div>

          {/* Social Proof */}
          <div className="flex items-center justify-center gap-2 text-gray-600 text-xs md:text-sm" data-id="element-87">
            <div className="flex -space-x-2" data-id="element-88">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 border-2 border-white" data-id="element-89"></div>)}
            </div>
            <span className="font-medium" data-id="element-90">
              +500 docentes ya transformaron sus clases
            </span>
          </div>
        </div>
      </header>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-91">
        <div className="max-w-3xl mx-auto" data-id="element-92">
          <h3 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-93">
            ⏳ ¿Te suena familiar?
          </h3>

          <div className="space-y-6 text-lg text-gray-700 bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-3xl shadow-lg border border-red-100" data-id="element-94">
            <p className="font-semibold text-xl text-gray-900" data-id="element-95">
              La sensación de no llegar nunca se repite semana tras semana...
            </p>

            <ul className="space-y-5" data-id="element-96">
              <li className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-97">
                <span className="text-2xl" data-id="element-98">🧠</span>
                <span className="font-medium" data-id="element-99">
                  Pasás horas armando clases desde cero
                </span>
              </li>
              <li className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-100">
                <span className="text-2xl" data-id="element-101">🔁</span>
                <span className="font-medium" data-id="element-102">
                  Cuando terminás, ya estás pensando en la siguiente
                </span>
              </li>
              <li className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-103">
                <span className="text-2xl" data-id="element-104">😓</span>
                <span className="font-medium" data-id="element-105">
                  Trabajás mucho, pero sentís que nunca alcanza
                </span>
              </li>
              <li className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-106">
                <span className="text-2xl" data-id="element-107">📚</span>
                <span className="font-medium" data-id="element-108">
                  Llegás al aula cansado/a antes de empezar
                </span>
              </li>
            </ul>

            <div className="mt-8 p-6 bg-white rounded-xl border-l-4 border-red-500 shadow-md" data-id="element-109">
              <p className="font-bold text-gray-900 text-lg" data-id="element-110">
                No es falta de vocación. Es falta de un sistema claro y material
                listo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-20 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-111">
        <div className="max-w-5xl mx-auto" data-id="element-112">
          <div className="text-center mb-16" data-id="element-113">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-114">
              🌍 Por eso creamos el
              <br data-id="element-115" />
              MEGAPACK GEOGRAFÍA LISTA
            </h2>
            <p className="text-xl text-gray-600 font-medium" data-id="element-116">
              Un sistema completo para entrar al aula con todo resuelto
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-117">
            {[{
            icon: BookOpen,
            title: 'Todo el año organizado',
            desc: '6 libros digitales listos para nivel medio',
            color: 'from-blue-500 to-blue-600'
          }, {
            icon: Layout,
            title: 'Clases listas para aplicar',
            desc: 'Actividades que ya funcionan, sin empezar de cero',
            color: 'from-purple-500 to-purple-600'
          }, {
            icon: Map,
            title: 'Contenidos claros y visuales',
            desc: 'Teoría simple, mapas e imágenes que ayudan a explicar',
            color: 'from-green-500 to-green-600'
          }, {
            icon: Clock,
            title: 'Más tiempo y tranquilidad',
            desc: 'Ahorrás semanas de trabajo y enseñás con seguridad',
            color: 'from-orange-500 to-orange-600'
          }].map((item, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100" data-id="element-118">
                <div className={`bg-gradient-to-br ${item.color} w-14 h-14 rounded-2xl flex items-center justify-center mb-5 shadow-lg`} data-id="element-119">
                  <item.icon className="text-white w-7 h-7" data-id="element-120" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-121">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-122">{item.desc}</p>
              </div>)}
          </div>

          <div className="text-center mt-16" data-id="element-123">
            <p className="text-2xl text-blue-600 font-bold mb-8" data-id="element-124">
              ✨ Menos estrés. Más orden. Más disfrute al enseñar.
            </p>
            <Button onClick={scrollToPurchase} size="lg" data-id="element-125">
              VER OFERTA ESPECIAL
            </Button>
          </div>
        </div>
      </section>

      {/* PRODUCT CONTENTS */}
      <section className="py-20 px-4 bg-white" data-id="element-126">
        <div className="max-w-4xl mx-auto" data-id="element-127">
          <h2 className="text-4xl font-black text-center text-gray-900 mb-4" data-id="element-128">
            📦 ¿Qué incluye el Megapack?
          </h2>
          <p className="text-center text-gray-600 mb-12 text-xl" data-id="element-129">
            Todo el material listo para usar en nivel medio
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-130">
            {[{
            icon: Globe2,
            title: 'Libro 1',
            desc: 'Orientación espacial, mapas, puntos cardinales y actividades dinámicas',
            color: 'text-blue-600',
            bg: 'bg-blue-50'
          }, {
            icon: Leaf,
            title: 'Libro 2',
            desc: 'Relieve, climas, paisajes naturales y actividades prácticas',
            color: 'text-green-600',
            bg: 'bg-green-50'
          }, {
            icon: TrendingUp,
            title: 'Libro 3',
            desc: 'Población, migraciones, recursos, gráficos y análisis guiado',
            color: 'text-orange-600',
            bg: 'bg-orange-50'
          }, {
            icon: Globe2,
            title: 'Libro 4',
            desc: 'Globalización, economía mundial, regiones y proyectos',
            color: 'text-red-600',
            bg: 'bg-red-50'
          }, {
            icon: Leaf,
            title: 'Libro 5',
            desc: 'Ambiente, desarrollo sostenible, geopolítica y casos reales',
            color: 'text-purple-600',
            bg: 'bg-purple-50'
          }, {
            icon: TrendingUp,
            title: 'Libro 6',
            desc: 'Economía, producción y análisis territorial',
            color: 'text-indigo-600',
            bg: 'bg-indigo-50'
          }].map((book, idx) => <div key={idx} className={`flex items-start gap-4 p-6 rounded-2xl ${book.bg} border-2 border-gray-100`} data-id="element-131">
                <book.icon className={`w-10 h-10 flex-shrink-0 ${book.color}`} data-id="element-132" />
                <div data-id="element-133">
                  <h3 className={`font-black text-xl ${book.color} mb-2`} data-id="element-134">
                    {book.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-135">{book.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-3xl text-center border-2 border-blue-100" data-id="element-136">
            <div className="flex flex-col md:flex-row justify-center gap-6 text-lg font-semibold text-gray-800 mb-4" data-id="element-137">
              <span className="flex items-center justify-center gap-2" data-id="element-138">
                <Check className="text-green-500 w-6 h-6" data-id="element-139" /> Formato PDF listo
                para imprimir
              </span>
              <span className="flex items-center justify-center gap-2" data-id="element-140">
                <Check className="text-green-500 w-6 h-6" data-id="element-141" /> Acceso inmediato y
                de por vida
              </span>
            </div>
            <p className="text-blue-600 font-black text-xl pt-2" data-id="element-142">
              💡 Ahorrá tiempo y llevá tus clases a un nivel superior 🚀
            </p>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <Bonuses onScrollToPurchase={scrollToPurchase} data-id="element-143" />

      {/* PURCHASE SECTION - CLEAN & SIMPLE */}
      <section ref={purchaseRef} id="purchase-section" className="py-20 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-144">
        <div className="max-w-3xl mx-auto" data-id="element-145">
          {/* Simple urgency indicator */}
          <div className="text-center mb-8" data-id="element-146">
            <div className="inline-flex items-center gap-3 bg-red-50 text-red-700 px-6 py-3 rounded-full text-sm font-medium border border-red-200 mb-4" data-id="element-147">
              <Clock className="w-4 h-4" data-id="element-148" />
              <span data-id="element-149">Oferta termina en:</span>
              <CountdownTimer data-id="element-150" />
            </div>
            <p className="text-gray-600 text-sm" data-id="element-151">
              Solo quedan 23 cupos a este precio
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border-2 border-blue-200" data-id="element-152">
            <div className="p-8 md:p-12" data-id="element-153">
              <div className="text-center mb-8" data-id="element-154">
                <h2 className="text-3xl font-black text-gray-900 mb-2" data-id="element-155">
                  Megapack Geografía Lista
                </h2>
                <p className="text-gray-600" data-id="element-156">+ Todos los bonos incluidos</p>
              </div>

              {/* Simple value list */}
              <div className="bg-blue-50 rounded-2xl p-6 mb-8" data-id="element-157">
                <h3 className="font-bold text-gray-900 mb-4 text-lg" data-id="element-158">
                  Todo lo que recibirás:
                </h3>
                <ul className="space-y-3" data-id="element-159">
                  {['6 Libros Digitales Completos', 'Actividades Listas para Usar', 'Recursos Visuales y Mapas', 'Acceso de Por Vida', 'Actualizaciones Futuras GRATIS'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-160">
                      <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-161" />
                      <span data-id="element-162">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Clean pricing */}
              <div className="text-center mb-8" data-id="element-163">
                <p className="text-gray-500 text-sm mb-2" data-id="element-164">
                  Precio regular: <span className="line-through" data-id="element-165">$47 USD</span>
                </p>
                <div className="mb-4" data-id="element-166">
                  <span className="text-6xl font-black text-blue-600" data-id="element-167">
                    $12.99
                  </span>
                  <span className="text-xl text-gray-500 ml-2" data-id="element-168">USD</span>
                </div>
                <p className="text-green-600 font-bold text-lg mb-2" data-id="element-169">
                  Ahorrás $34.01 (72% de descuento)
                </p>
                <p className="text-sm text-gray-500" data-id="element-170">
                  *Pagarás en la moneda de tu país
                </p>
              </div>

              {/* Single clear CTA */}
              <Button href={CHECKOUT_URL} fullWidth size="lg" className="mb-6" data-id="element-171">
                ACCEDER AHORA
              </Button>

              <p className="text-center text-sm text-gray-600 mb-8" data-id="element-172">
                ⚡ Acceso instantáneo después del pago
              </p>

              {/* Trust indicators */}
              <div className="grid grid-cols-3 gap-4 mb-8" data-id="element-173">
                <div className="text-center" data-id="element-174">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-175">
                    <ShieldCheck className="w-6 h-6 text-green-600" data-id="element-176" />
                  </div>
                  <p className="text-xs text-gray-600 font-medium" data-id="element-177">
                    Pago Seguro
                  </p>
                </div>
                <div className="text-center" data-id="element-178">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-179">
                    <Zap className="w-6 h-6 text-blue-600" data-id="element-180" />
                  </div>
                  <p className="text-xs text-gray-600 font-medium" data-id="element-181">
                    Acceso Inmediato
                  </p>
                </div>
                <div className="text-center" data-id="element-182">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-183">
                    <Check className="w-6 h-6 text-purple-600" data-id="element-184" />
                  </div>
                  <p className="text-xs text-gray-600 font-medium" data-id="element-185">
                    Garantía 7 Días
                  </p>
                </div>
              </div>

              {/* Simple guarantee */}
              <div className="bg-green-50 rounded-2xl p-6 border-2 border-green-200" data-id="element-186">
                <div className="flex items-start gap-4" data-id="element-187">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-188">
                    <ShieldCheck className="w-6 h-6 text-white" data-id="element-189" />
                  </div>
                  <div data-id="element-190">
                    <h3 className="font-bold text-gray-900 mb-1" data-id="element-191">
                      Garantía de 7 días
                    </h3>
                    <p className="text-gray-700 text-sm" data-id="element-192">
                      Si no te convence, te devolvemos el 100% de tu dinero. Sin
                      preguntas.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Security note */}
          <div className="mt-6 text-center" data-id="element-193">
            <p className="text-gray-600 text-xs" data-id="element-194">
              🔒 Pago seguro con encriptación SSL · Procesado por Shopify
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <Testimonials data-id="element-195" />

      {/* FAQ SECTION */}
      <section className="py-20 px-4 bg-white" data-id="element-196">
        <div className="max-w-3xl mx-auto" data-id="element-197">
          <h2 className="text-4xl font-black text-center text-gray-900 mb-12" data-id="element-198">
            ❓ Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-199">
            {[{
            q: '¿Puedo usarlo en clases presenciales y online?',
            a: 'Sí, el material funciona perfectamente para ambos formatos. Los PDFs son imprimibles y también se pueden proyectar o compartir digitalmente.'
          }, {
            q: '¿Es digital o físico?',
            a: '100% digital. Recibirás acceso inmediato para descargar todos los materiales en formato PDF.'
          }, {
            q: '¿Cómo recibo el material?',
            a: 'Inmediatamente después de la compra recibirás un email con el enlace de descarga. Acceso instantáneo.'
          }, {
            q: '¿Necesito experiencia previa?',
            a: 'No. El material está diseñado para ser usado directamente, sin necesidad de conocimientos técnicos.'
          }, {
            q: '¿Es seguro comprar?',
            a: 'Totalmente seguro. Usamos encriptación SSL de nivel bancario y procesamiento seguro por Shopify.'
          }, {
            q: '¿Cuánto tiempo tengo acceso?',
            a: 'Acceso de por vida. Una vez que compras, el material es tuyo para siempre, incluyendo futuras actualizaciones.'
          }].map((faq, i) => <div key={i} className="bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-100 rounded-2xl p-6" data-id="element-200">
                <h3 className="font-bold text-xl text-gray-900 mb-3" data-id="element-201">
                  {faq.q}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-202">{faq.a}</p>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-203">
            <Button onClick={scrollToPurchase} size="lg" data-id="element-204">
              ACCEDER AHORA
            </Button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-205">
        <p className="mb-4 font-medium" data-id="element-206">
          © 2024 Megapack Geografía Lista. Todos los derechos reservados.
        </p>
        <p className="text-xs" data-id="element-207">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
        </p>
      </footer>

      <style jsx data-id="element-208">{`
        @keyframes slide-in {
          from {
            transform: translateX(-100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        .animate-slide-in {
          animation: slide-in 0.5s ease-out;
        }
      `}</style>
    </div>;
}